import { FlexRowMixin } from 'common/components/common/style';
import { ClampContainerMixin } from 'common/components/Typography';
import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
const { font_color_c, font_color_d, font_color_white, SAFE_AREA_VIEW_PADDING } = variables;

GlobalStyle.inject`
  .description-container {
    display: flex;
    flex-direction: column;
    padding-left: ${SAFE_AREA_VIEW_PADDING}px;
    z-index: 2;
    max-width: 50%;
  }

  .description-row-container {
    ${FlexRowMixin}
    padding: ${`${getScalablePixel(4)}px 0`};
    justify-content: flex-start;
    font-size: ${getScalablePixel(22)}px;
    font-weight: bold;
    line-height: 1;
    color: ${font_color_c};
    & > *:not(:first-child) {
      margin-left: ${getScalablePixel(12)}px;
    }
  }

  .description-title {
    ${ClampContainerMixin({ lines: 1 })}
    font-size: ${getScalablePixel(52)}px;
    font-weight: bold;
    color: ${font_color_white};
    word-break: break-word;

    &.large {
      font-size: ${getScalablePixel(72)}px;
    }

    &.weight-normal {
      font-weight: normal;
    }
  }

  .description-duration {
    white-space: nowrap;
  }

  .description-date-row {
    text-transform: uppercase;
    font-weight: normal;
    color: ${font_color_c};
    font-size: ${getScalablePixel(21)}px;
    padding: ${`${getScalablePixel(8)}px 0`};
  }

  .description-date-row-time {
    font-weight: bold;
  }

  .description-main-info {
    ${ClampContainerMixin({})}
    word-break: break-word;
    color: ${font_color_white};
    font-size: ${getScalablePixel(24)}px;
    /* margin-bottom: 16px; */
  }

  .description-staff-container {
    color: ${font_color_white};
    display: flex;
    flex-direction: column;
    flex: 0 0 40%;
    padding: ${`${getScalablePixel(16)}px 0`};
  }

  .description-staff-row {
    display: flex;
    align-items: baseline;
  }

  .description-staff-title {
    color: ${font_color_d};
    font-weight: bold;
    font-size: ${getScalablePixel(24)}px;
    text-align: left;
    flex: 0 0 ${getScalablePixel(134)}px;

    &.right {
      text-align: right;
    }
  }

  .description-staff-data {
    ${ClampContainerMixin({})}
    font-size: ${getScalablePixel(22)}px;
    padding: ${`0 ${getScalablePixel(16)}px`};
    flex: 1;
  }
`;
